import { makeStyles, Text, tokens } from '@fluentui/react-components';
import { Video20Regular } from '@fluentui/react-icons';
import React from 'react';

const useStyles = makeStyles({
  card: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
    backgroundColor: tokens.colorNeutralBackground1,
    borderRadius: tokens.borderRadiusLarge,
    boxShadow: `0 8px 24px ${tokens.colorNeutralShadowAmbient}, 0 4px 8px ${tokens.colorNeutralShadowKey}`,
    border: `1px solid ${tokens.colorBrandStroke1}`,
    maxWidth: '280px',
    cursor: 'grabbing',
  },
  icon: {
    color: tokens.colorBrandForeground1,
    flexShrink: 0,
  },
  name: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightMedium,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});

interface DragOverlayCardProps {
  name: string;
}

export const DragOverlayCard = ({ name }: DragOverlayCardProps) => {
  const styles = useStyles();

  return (
    <div className={styles.card}>
      <Video20Regular className={styles.icon} />
      <Text className={styles.name}>{name || 'Réunion sans titre'}</Text>
    </div>
  );
};
